import type { DiagnosticEventSender } from './types';

const SELECTORS = '[data-selenium],[data-testid],button,a,[role="button"]';

export function initInteractionTracker(
  send: DiagnosticEventSender,
): () => void {
  const onClick = (e: MouseEvent) => {
    const target = e.target as Element | null;
    if (!target) return;

    const el = target.closest(SELECTORS);
    if (!el) return;

    const htmlEl = el as HTMLElement;
    const sel =
      htmlEl.dataset?.['selenium'] ||
      htmlEl.dataset?.['testid'] ||
      htmlEl.getAttribute('aria-label') ||
      el.tagName.toLowerCase();

    send({
      t: 'click',
      sel,
      text: (htmlEl.textContent || '').trim().slice(0, 60) || undefined,
    });
  };

  document.addEventListener('click', onClick, true);

  return () => {
    document.removeEventListener('click', onClick, true);
  };
}
